import { useEffect, useState } from 'react';
import { SepPlansReviewMessage } from './SepPlans/SepPlansReviewMessage';
import Alert from '@mui/material/Alert';
import { getSepSearchResults } from '../shared/APIHelper';
import { PLAN_STATUS } from '../shared/AppConstants';

const SepPlansBanner = ({ loggedInUser }) => {
  const [sbmReviewPlans, setSbmReviewPlans] = useState([]);

  const checkForSepPlansToReview = async () => {
    const programs = await getSepSearchResults(loggedInUser.toUpperCase());
    const programsWithAtleastOnePlan = programs.flatMap(
      (program) => program.plans
    );
    const sbmReviewPlans = programsWithAtleastOnePlan.filter(
      (plan) => plan.latestStatus?.planStatusType === PLAN_STATUS.SBM_REVIEW
    );
    setSbmReviewPlans(sbmReviewPlans);
  };

  useEffect(() => {
    if (loggedInUser) {
      checkForSepPlansToReview();
    }
  }, [loggedInUser]);

  return (
    sbmReviewPlans.length > 0 && (
      <Alert severity="informational">
        <SepPlansReviewMessage
          sepPlansToReview={sbmReviewPlans}
          showSepPlanTabMessage={false}
        />
      </Alert>
    )
  );
};

export default SepPlansBanner;
